import React, {Component} from 'react';
import {translate} from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';

var Config = require('../../config');

class PlasmaticProductForm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleCheck = this.handleCheck.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);

		this.state = {
			name:"",
			code:"",
			barcode:"",
			presentation:"",
			presentation_list:[],
			unit:"",
			method:"",
			cost:"",
			volume:"",
			active: true
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'lookups?type=presentation&notRender=0', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					presentation_list: response
				});
			}
		});


		if(this.props.match.params.id !== undefined){
			this.setState({method: 'put'});

			fetch(Config.default.apiGateway.URL+'plasmatic_product?id='+this.props.match.params.id, {
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						name: response.name,
						code: response.code,
						barcode: response.barcode,
						presentation: response.presentation,
						unit: response.units,
						cost: response.cost_unit,
						active: response.active,
						volume: response.volume
					});
				}
			});
		}else{
			this.setState({method: 'post'});
		}
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.name === 'presentation'){
			if(e.target.value === 'BOLSA'){
				this.setState({unit: 1});
			}else{
				this.setState({unit:''});
			}
		}
		if(e.target.value !== ""){
			document.getElementById(e.target.id).classList.remove('error');
		}
	}

	//Evento para checkbox
	handleCheck = event => {
		this.setState({ 
			[event.target.name]: event.target.checked
		});
	}

	onSave(){
		if(this.isValidForm()){
			var obj = {};
			var url = "";

			if(this.props.match.params.id !== undefined){
				obj.id = this.props.match.params.id;
				url = 'plasmatic_product?id='+this.props.match.params.id;
			}else{
				url = 'plasmatic_product';
			}

			obj.name = this.state.name;
			obj.code = this.state.code;
			obj.barcode = this.state.barcode;
			obj.presentation = this.state.presentation;
			obj.units = this.state.unit;
			obj.active = this.state.active;
			obj.cost_unit = this.state.cost;
			obj.volume = this.state.volume;

			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+url, {
				method: this.state.method,
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res;
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					swal("Correcto", "Registro guardado correctamente.", 'success');
					this.onCancel();
				}
			});
		}else{
			swal('Error', 'Campos incompletos.', 'error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		//console.log(refName+' is required');
		var res = null;
		var control = document.getElementById(refName);

		if(control.required){
			if (control.value === "") {
				if(control !== null){
					control.classList.add('error');
				}
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
				}
				res = true;
			}
		}

		return res;
	}

	onCancel(){
		this.props.history.push('/plasmatic_products');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.plasmatic_products.MAIN')} ->
						Nuevo
					</h5>
				</div>

				<form noValidate>
					<fieldset className="col-xs-12">
						<legend>Producto Plasmatico</legend>
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Nombre</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="text" className="form-control" name="name" id="name" required
									onChange={this.handleChange} value={this.state.name} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Código</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="text" className="form-control" name="code" id="code" 
									onChange={this.handleChange} value={this.state.code} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Código Barras</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="text" className="form-control" name="barcode" id="barcode" 
									onChange={this.handleChange} value={this.state.barcode} />
							</div>
						</div>
						
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Presentación</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<select className="form-control" name="presentation" id="presentation" 
									onChange={this.handleChange} value={this.state.presentation} required>
									<option value="">Seleccione...</option>
									{this.state.presentation_list.map((p, i)=>{
										return <option key={i} value={p.name}>
											{p.name}
										</option>
									})}
								</select>
							</div>
						</div>
						{this.state.presentation === 'BOLSA' &&
							<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
								<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
									<span className="span-min">Volumen</span>
								</div>
								<div className="col-xs-12 col-sm-4">
									<input type="number" className="form-control hour-input" name="volume" id="volume" 
										onChange={this.handleChange} value={this.state.volume} required/>
								</div>
							</div>
						}
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Unidades</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="number" className="form-control hour-input" name="unit" id="unit" 
									onChange={this.handleChange} value={this.state.unit} required
									disabled={this.state.presentation === 'BOLSA'}
									/>
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Costo</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="number" className="form-control hour-input" name="cost" id="cost" 
									onChange={this.handleChange} value={this.state.cost} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Activo</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="checkbox" id="active" name="active" 
								checked={this.state.active} onChange={this.handleCheck}/>
							</div>
						</div>
							

						<div className="col-xs-12 col-sm-9" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onCancel} style={{margin:12}}/>
				        	</div>
				        </div>
					</fieldset>
				</form>
			</div>
		)
	}
}

export default translate('translations') (PlasmaticProductForm);